import queryString from 'query-string';
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import { connectRoutes } from 'redux-first-router';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import reducers from 'Data/reducers';
import constants from 'Services/constants';
import { EMPTY_OBJ } from 'Services/constants/empty';
import { modalTypes } from 'Services/constants/modals';
import routesMap from './routes';

const { reducer, middleware, enhancer } = connectRoutes(routesMap, {
  location: (state) => state.Location,
  querySerializer: queryString,
  displayConfirmLeave: (message, callback) => {
    const canLeave = (can) => {
      store.dispatch({ type: 'MODAL_CLOSE_ALL' }); // eslint-disable-line no-use-before-define
      return callback(can);
    };

    store.dispatch({ // eslint-disable-line no-use-before-define
      type: 'MODAL_OPEN',
      payload: {
        id: 'meetingProtector',
        type: modalTypes.CUSTOM,
        modalProps: {
          message,
          canLeave,
        },
      },
    });
  },
});

const middlewares = [middleware, thunkMiddleware];

let composeEnhancers = compose;

if (!constants.IS_PRODUCTION) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
  middlewares.push(createLogger());
}

function configureStore(preloadedState) {
  return createStore(
    combineReducers({ Location: reducer, ...reducers }),
    preloadedState,
    composeEnhancers(enhancer, applyMiddleware(...middlewares))
  );
}

const store = configureStore(EMPTY_OBJ);

export default store;
